<template>
  <div class="movie-player" :style="fillerStyle" :class="{ fullscreen }">
    <div class="movie-player__innerwrap" :style="innerwrapStyle">

      <video v-if="autoplay" class="movie-player__video"
        :class="{hidden: !played || ended}"
        :src="movieUrl"
        @timeupdate="onTimeUpdate"
        playsinline
        webkit-playsinline
      >
      </video>
      <video v-if="!autoplay" class="movie-player__video"
        :class="{hidden: !played || ended}"
        :src="movieUrl"
        @timeupdate="onTimeUpdate"
        playsinline
        webkit-playsinline
      >
      </video>

      <div class="movie-player__overlay" :style="{maxWidth: maxWidth}" @click="enableControls">
        <div class="movie-player__aspectratio" :style="{ paddingTop: ((aspectRatio * 100) + '%')}"></div>
        <div class="movie-player__placeholder" v-on:click="playPause" :class="{ hidden: played && !ended }" v-bind:style="{ backgroundImage: 'url(' + placeholderUrl + ')' }"></div>
        <a :class="{ hidden: !controlsActive, paused: paused }" v-on:click="playPause" class="movie-player__play"></a>
        <movie-progress-bar :class="{ hidden: !controlsActive }" @change="updateTime" :progress="progress"></movie-progress-bar>
        <a class="movie-player__mute" :class="{ hidden: !controlsActive, muted: muted }" v-on:click="toggleMute"></a>
        <a class="movie-player__fullscreen" :class="{ hidden: !controlsActive, fullscreen: fullscreen }" v-on:click="toggleFullscreen"></a>
      </div>

    </div>
  </div>
</template>

<script>
import MovieProgressBar from '@/components/MovieProgressBar';

const keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

function preventDefault(e) {
  const ev = e || window.event;
  if (ev.preventDefault) {
    ev.preventDefault();
  }
  ev.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
  return true;
}

function disableScroll() {
  if (window.addEventListener) { // older FF
    window.addEventListener('DOMMouseScroll', preventDefault, false);
  }
  window.onwheel = preventDefault; // modern standard
  window.onmousewheel = preventDefault; // older browsers, IE
  document.onmousewheel = preventDefault; // older browsers, IE
  window.ontouchmove = preventDefault; // mobile
  document.onkeydown = preventDefaultForScrollKeys;
}

function enableScroll() {
  if (window.removeEventListener) {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
  }
  document.onmousewheel = null;
  window.onmousewheel = null;
  window.onwheel = null;
  window.ontouchmove = null;
  document.onkeydown = null;
}

export default {
  name: 'movie-player',
  components: { MovieProgressBar },
  props: ['movieUrl', 'placeholderUrl', 'autoplay'],
  data() {
    return {
      played: false,
      paused: true,
      ended: false,
      fullscreen: false,
      muted: true,
      progress: 0,
      controlsActive: true,
      controlsTimeout: false,
      aspectRatio: 0.5625,
      maxWidth: false,

      fillerStyle: {},
      innerwrapStyle: {},

      elVideo: null,
      elOverlay: null,
      elInnerwrap: null,


      timeout: false,
      video: null,
    };
  },
  mounted() {
    this.elVideo = this.$el.querySelector('.movie-player__video');
    this.elOverlay = this.$el.querySelector('.movie-player__overlay');
    this.elInnerwrap = this.$el.querySelector('.movie-player__innerwrap');
    this.maxWidth = (window.innerHeight - 70) / this.aspectRatio + 'px';  //eslint-disable-line

    window.addEventListener('resize', () => {
      this.maxWidth = (window.innerHeight - 70) / this.aspectRatio + 'px';  //eslint-disable-line
    });


    this.$el.addEventListener('mousemove', () => {
      this.enableControls();
    });

    if (this.muted) {
      this.elVideo.muted = true;
    }

    if (this.autoplay) {
      // this.elVideo.addEventListener('canplaythrough', this.playPause);
    }

    this.elVideo.addEventListener('click', this.playPause);
  },
  methods: {
    toggleShowNav() {
      clearTimeout(this.navTimeout);
      this.showNav = true;

      this.navTimeout = setTimeout(() => {
        this.showNav = false;
      }, 12500);
    },
    playPause() {
      const video = this.$el.querySelector('.movie-player__video');
      if (!this.played) {
        this.elVideo.removeEventListener('canplaythrough', this.playPause);
        video.addEventListener('ended', () => {
          this.paused = true;
          this.ended = true;
          clearTimeout(this.navTimeout);
          this.controlsActive = true;
        });

        video.play();
        this.played = true;
        this.controlsActive = false;
        this.paused = false;
      } else if (this.ended) {
        this.ended = false;
        this.paused = false;
        video.currentTime = 0;
        video.play();
      } else if (this.paused) {
        video.play();
        this.paused = false;
      } else {
        video.pause();
        this.paused = true;
      }
    },
    maximize() {
      disableScroll();

      this.aspectRatio = this.elVideo.offsetHeight / this.elVideo.offsetWidth;


      this.fillerStyle = {
        height: this.$el.offsetHeight + 'px', //eslint-disable-line
        width: this.$el.offsetWidth + 'px', //eslint-disable-line
      };


      const rect = this.elInnerwrap.getBoundingClientRect();
      const top = rect.top;
      const left = rect.left;

      this.innerwrapStyle = {
        top: top + 'px', //eslint-disable-line
        left: left + 'px', //eslint-disable-line
        height: this.elInnerwrap.offsetHeight + 'px', //eslint-disable-line
        width: this.elInnerwrap.offsetWidth + 'px', //eslint-disable-line
        position: 'fixed',
      };


      this.timeout = setTimeout(() => {
        this.elOverlay.classList.add('aspect-ratio');
        this.elOverlay.classList.add('center');
        this.elInnerwrap.classList.add('movie-player__innerwrap--full');
      }, 80);
    },
    minimize() {
      this.elInnerwrap.classList.remove('movie-player__innerwrap--full');
      this.elOverlay.classList.remove('aspect-ratio');


      setTimeout(() => {
        enableScroll();
        this.elOverlay.classList.remove('center');

        this.fillerStyle = {};
        this.innerwrapStyle = {};
      }, 500);
    },
    toggleFullscreen() {
      clearTimeout(this.timeout);
      if (this.fullscreen) {
        this.minimize();
        this.fullscreen = false;
      } else {
        this.fullscreen = true;
        this.maximize();
      }
    },
    toggleMute() {
      // clearTimeout(this.timeout);
      if (this.muted) {
        this.muted = false;
        this.elVideo.removeAttribute('muted');
        this.elVideo.muted = false;
      } else {
        this.muted = true;
        this.elVideo.setAttribute('muted', true);
        this.elVideo.muted = true;
      }
    },
    onTimeUpdate() {
      this.progress = this.elVideo.currentTime / this.elVideo.duration;
    },
    enableControls() {
      this.controlsActive = true;
      clearTimeout(this.controlsTimeout);

      this.controlsTimeout = setTimeout(() => {
        this.controlsActive = false;
      }, 2000);
    },
    updateTime(progress) {
      this.elVideo.currentTime = (progress * this.elVideo.duration);
      this.ended = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/helpers';

.movie-player {
  display: block;
  width: 100%;
  position: relative;
  z-index: 1;

  &.fullscreen {
    z-index: 3;
  }


  &__innerwrap {
    @include gradientBackground;
    position: relative;
    transition: width .5s ease-in-out, height .5s ease-in-out, top .5s ease-in-out, left .5s ease-in-out, background .5s ease-in-out;

    &--full {
      position: fixed;
      top: 0 !important;
      left: 0 !important;
      width: 100% !important;
      height: calc(100% - 70px) !important;
    }
  }

  &__video {
    width: 100%;
    height: 100%;
    display: block;
    transition: opacity .3s cubic-bezier(.75,.01,.25,1);

    &.hidden {
      opacity: 0;
    }
  }

  &__overlay {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    transition: max-width .5s ease-in-out;
    width: 100%;

    &:not(.aspect-ratio) {
      max-width: 100% !important;
    }

    &.center {
      top: 50%;
      bottom: auto;
      left: 50%;
      right: auto;
      transform: translate(-50%, -50%);
    }

  }

  &__aspectRatio {
    display: block;
  }

  &__placeholder {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    transition: opacity .3s cubic-bezier(.75,.01,.25,1);

    &.hidden {
      opacity: 0;
    }
  }

  &__fullscreen {
    display: block;
    height: 46px;
    width: 46px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../static/svg/icon_maximize.svg');
    position: absolute;
    top: 20px;
    right: 20px;
    transition: opacity .3s;
    z-index: 3;

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }

    &.fullscreen {
      background-image: url('../../static/svg/icon_minimize.svg');
    }
  }

  &__mute {
    display: block;
    height: 46px;
    width: 46px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../static/svg/icon_unmute.svg');
    position: absolute;
    top: 20px;
    right: 86px;
    transition: opacity .3s;
    z-index: 3;

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }

    &.muted {
      background-image: url('../../static/svg/icon_mute.svg');
    }
  }

  &__play {
    display: block;
    height: 84px;
    width: 84px;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url('../../static/svg/icon_play.svg');
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -42px;
    margin-left: -42px;
    transition: opacity .3s;
    z-index: 3;

    &.hidden {
      opacity: 0;
      pointer-events: none;
    }

    &:not(.paused) {
      background-image: url('../../static/svg/icon_pause.svg');
    }

    &.paused {
      background-image: url('../../static/svg/icon_play.svg');
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/MoviePlayer.vue